import { render, staticRenderFns } from "./ArtistPicturesAccordion.vue?vue&type=template&id=58145a87&"
import script from "./ArtistPicturesAccordion.vue?vue&type=script&lang=js&"
export * from "./ArtistPicturesAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports